import Character from "./Character";
import { CharacterAction } from "./CharacterAction";
import Item from "../item/Item";
import CharacterClass from "./CharacterClass";
import Thruster from "./Thruster";
import Values from "../value/Values";
import ValueCalculator from "../../util/ValueCalculator";

export default class PartyCharacter extends Character {
    /**
     * @param {CharacterClass} characterClass
     * @param {Values} values
     * @param {number} minerIndex
     */
    constructor(characterClass, values, minerIndex) {
        super();

        /**
         * @constant
         * @type {string}
         */
        this.id = '' + minerIndex;

        /**
         * @constant
         * @type {CharacterClass}
         */
        this.characterClass = characterClass;
        /**
         * @constant
         * @type {Values}
         */
        this.values = values;

        /**
         * @constant
         * @type {number}
         */
        this.minerIndex = minerIndex;

        /**
         * @type {Item}
         */
        this.pick = null;

        /**
         * @type {Thruster}
         */
        this.thruster = null;

        /**
         * @type {string}
         */
        this.characterAction = CharacterAction.STAND;
        /**
         * The timestamp when the current animation started.
         * @type {number}
         */
        this.characterActionStart = Date.now();

        /**
         * @type {string}
         */
        this.skillId = null;
    }

    /**
     * @override
     * @returns {boolean}
     */
    isMonster() {
        return false;
    }

    /**
     * @returns {boolean}
     */
    isPartyMember() {
        return true;
    }

    /**
     * Returns -1 if this isn't a miner in the crew.
     * @abstract
     * @returns {number}
     */
    getMinerIndex() {
        return this.minerIndex;
    }

    /**
     * @override
     * @param {number} frameTimeRatio 
     * @param {boolean} turnStart
     */
    performFrameActions(frameTimeRatio, turnStart) {
        if (!this.turnAction) {
            this.updateThrusterStatus();
            return;
        }

        this.turnAction.performAction(this, frameTimeRatio, turnStart);

        if (this.characterAction !== CharacterAction.FALL) {
            this.updateThrusterStatus();
        }
        else if (this.thruster.active) {
            this.thruster.deactivateNow();
        }
    }

    /**
     * @override
     * @param {number} frameTimeRatio 
     * @param {boolean} turnStart True if this is the start of a turn.
     */
    followPathPlan(frameTimeRatio, turnStart) {
        if (this.position.pathPlan.length === 0) {
            return;
        }

        const pathPlan = this.position.pathPlan[0];
        
        // Apply the fall speed skill bonus.
        if (this.values.fallSpeedBonusActive.isValue()) {
            pathPlan.fallSpeedMultiplier = ValueCalculator.getFallSpeedMultiplier(this.values.fallSpeedUpgrades.getValue());
        }
        else {
            pathPlan.fallSpeedMultiplier = 1;
        }

        if (pathPlan.executePlan(this, frameTimeRatio, turnStart)) {
            // We have completed a step in the plan.
            this.position.pathPlan.shift();
        }
        // else we are still working on the current step.
    }

    // /**
    //  * @override
    //  * @param {number} frameTimeRatio 
    //  * @param {boolean} turnStart True if this is the start of a turn.
    //  */
    // followPathPlan(frameTimeRatio, turnStart) {
    //     if (this.position.pathPlan.length === 0) {
    //         return;
    //     }

    //     const pathPlan = this.position.pathPlan[0];
        
    //     // Apply the fall speed skill bonus.
    //     if (this.values.fallSpeedBonusActive.isValue()) {
    //         pathPlan.fallSpeedMultiplier = ValueCalculator.getFallSpeedMultiplier(this.values.fallSpeedUpgrades.getValue());
    //     }
    //     else {
    //         pathPlan.fallSpeedMultiplier = 1;
    //     }

    //     if (pathPlan.executePlan(this, frameTimeRatio, turnStart)) {

    //         // We have completed a step in the plan.
    //         this.position.pathPlan.shift();

    //         // Check to see if we need to add in the platform tile.
    //         if (this.position.pathPlan.length > 0) {
    //             const next = this.position.pathPlan[0];
    //             if (next.isSolidFloorRequiredAtStart()) {
    //                 this.updateThrusterStatus();
    //             }
    //         }
    //         else {
    //             // We're done with our path
    //             this.updateThrusterStatus();
    //             this.pathCompletedTime = Date.now();
    //         }
    //     }
    //     // else we are still working on the current step.
    // }


    /**
     * @private
     * Check to see if the tile below the character is open air, and if so, add in a sand block.
     * This should be invoked at the end of a path plan execution, unless it is a 'falling' plan.
     */
    updateThrusterStatus() {
        const tile = this.position.tile;
        const neighbor = tile.getNeighborBottom();

        if (!neighbor || neighbor.isTraversable()) {
            this.thruster.setActive(true);
        }
        else {
            this.thruster.deactivateNow();
        }
    }

    /**
     * @override
     * @param {number} characterAction  See CharacterAction
     */
    setCharacterAction(characterAction) {
        if (this.characterAction !== characterAction) {
            this.characterAction = characterAction;
            this.characterActionStart = Date.now();
        }

        // Let the item know if it is 'active' (swinging animation)
        this.pick.setItemActive(this.characterAction === CharacterAction.MINE);

        // Based on our current action, see if we need thrusters.
        if (this.characterAction !== CharacterAction.JUMP && this.characterAction !== CharacterAction.FALL) {
            this.updateThrusterStatus();
        }
    }

    /**
     * @returns {Sprite}
     */
    getCharacterSprite() {
        return this.characterClass.getSprite(this.characterAction, this.characterActionStart);
    }

    /**
     * @returns {Sprite}
     */
    getItemOverlaySprite() {
        if (this.pick) {
            return this.pick.getItemOverlaySprite();
        }

        return null;
    }

    /**
     * @returns {Sprite}
     */
    getThrusterOverlaySprite() {
        return this.thruster.getOverlaySprite();
    }

    /**
     * @override
     * @returns {boolean}
     */
    isThrusterActive() {
        return this.thruster.isActive();
    }

}